<app-treaty-country-pair-selector
  [selectedCountry] = selectedCountry
  [selectedCountryTwo] = selectedCountryTwo
  (countryChange) = "onCountryChange($event)"
  (countryTwoChange) = "onCountryTwoChange($event)"
>
</app-treaty-country-pair-selector>
